import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { useAuth } from "../../contexts/AuthContext";
import removeFavorite from "./removeFav";
import { Link } from "react-router-dom";

interface Product {
  id: string;
  name: string;
  description: string;
  price: string;
  image: string;
}

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState<Product[]>([]);
  const { user } = useAuth();

  const fetchFavorites = async () => {
    const favDocRef = doc(db, "favorites", user.uid);
    try {
      const docSnap = await getDoc(favDocRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        const favoriteList = await Promise.all(
          Object.entries(data).map(async ([key, details]) => {
            const productRef = doc(db, "proudcts", key);
            const productSnap = await getDoc(productRef);
            if (productSnap.exists()) {
              return { id: key, ...productSnap.data() } as Product;
            } else {
              return null;
            }
          })
        );
        setFavorites(
          favoriteList.filter((product) => product !== null) as Product[]
        );
      }
    } catch (error) {
      console.error("Error fetching favorites:", error);
    }
  };

  const handleRemove = async (productId: string) => {
    try {
      await removeFavorite(user.uid, productId);
      setFavorites((prev) =>
        prev.filter((product) => product.id !== productId)
      );
    } catch (error) {
      console.error("Error removing favorite:", error);
    }
  };

  useEffect(() => {
    fetchFavorites();
  }, []);

  return (
    <div className="px-5 lg:px-36 py-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-center">
        Your Favorite Products
      </h1>
      {favorites.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {favorites.map((product) => (
            <div
              key={product.id}
              className="bg-white shadow-lg rounded-lg p-4 border border-gray-200 "
            >
              <div className="flex justify-center items-center mb-4">
                <Link to={`/products/${product.id}`}>
                  <img
                    className="h-40 w-full object-contain rounded-md"
                    src={product.image}
                    alt={product.name}
                  />
                </Link>
              </div>
              <Link
                to={`/products/${product.id}`}
                className="text-xl font-semibold mb-2 truncate hover:underline"
              >
                {product.name}
              </Link>
              <p className="text-gray-700 mb-4 line-clamp-2 h-12 overflow-hidden">
                {product.description}
              </p>
              <p className="text-lg font-bold mb-4">
                {product.price ? `$${product.price}` : "Price not available"}
              </p>
              <button
                onClick={() => handleRemove(product.id)}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-600">No favorite products found.</p>
      )}
    </div>
  );
};

export default FavoritesPage;
